import { useEffect, useState } from "react";
import Land from "../../Assets/images/tar1.png";
import Bank from "../../Assets/images/hs.png";
import ActiveSavingsCom from "./ActiveSavingsCom";
import TargetSavingDrawer from "./TargetSavingDrawer";
import TargetRentDrawer from "./TargetRentDrawer";
import getServices from "../../Services/get-service";
import { toast } from "react-toastify";
function Savings() {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const [open1, setOpen1] = useState(false);
  const handleClose1 = () => setOpen1(false);
  const handleOpen1 = () => setOpen1(true);
  const [savingsRent, setSavingsRent] = useState(0);
  const [savingsTarget, setSavingsTarget] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getServices
      .userGetSavingsWalletBalance()
      .then((response) => {
        if (response.data.statusCode === 200) {
          const data = response.data.data;
          setSavingsRent(data.rentageSavingsBalance || 0);
          setSavingsTarget(data.targetSavingsBalance || 0);
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.description, { autoClose: 1000 });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  return (
    <div className=" my-6">
      <TargetSavingDrawer open={open} handleClose={handleClose} />
      <TargetRentDrawer open={open1} handleClose={handleClose1} />
      <p className=" text-[14px] font-[500] text-[#808285] mb-2">My savings</p>
      <div className="  grid md:grid-cols-2 gap-4">
        <ActiveSavingsCom
          img={Land}
          title="Target savings"
          sub={savingsTarget}
          onClick={handleOpen}
          loading={loading}
        />
        <ActiveSavingsCom
          img={Bank}
          title="Rent savings"
          sub={savingsRent}
          onClick={handleOpen1}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default Savings;
